import { prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import { useResumeCounters } from './_data/counters'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import Accordion from '../../../../components/structure/accordion/Accordion'
import AccordionContent from '../../../../components/structure/accordion/AccordionContent'
import AccordionHeader from '../../../../components/structure/accordion/AccordionHeader'
import CheckInOutDetailsPanel from '../../_shared/panels/CheckInOutDetailsPanel'
import CustomFieldsPanel from '../../_shared/panels/CustomFieldsPanel'
import DocumentsDetailsPanel from '../../_shared/panels/DocumentsDetailsPanel'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import PlaceDetailsPanel from '../../_shared/place/PlaceDetailsPanel'
import ServiceOrderDetailsPanel from '../../_shared/panels/ServiceOrderDetailsPanel'
import ServiceOrderObservationsPanel from '../../_shared/panels/ServiceOrderObservationsPanel'
import StatusReasonPanel from '../../_shared/panels/StatusReasonPanel'
import StatusTag from '../../../../containers/serviceOrders/StatusTag'
import { shouldHideIndicators } from '../../../../utils/helpers/serviceOrder'
import SchedulingPanel from '../../_shared/panels/ServiceOrderSchedulingPanel'

const GeneralAccordion = () => {
  const { t } = useTranslation('serviceOrders')
  const serviceOrder = useServiceOrder()
  const place = prop('place', serviceOrder)
  const documents = prop('documents', serviceOrder)
  const status = prop('status', serviceOrder)
  const counters = useResumeCounters()

  return (
    <FlexCol>
      <Accordion startsOpen sticky lineBorder mediumPadding={false}>
        <AccordionHeader>
          <Grid justify="space-between">
            <Title size="h4" noMargin>
              {t('resume.accordion.general')}
            </Title>
            <StatusTag item={status} medium />
          </Grid>
        </AccordionHeader>
        <AccordionContent>
          <FlexGrid direction="column" align="stretch" gutter={0.5}>
            <ServiceOrderDetailsPanel
              serviceOrder={serviceOrder}
              counters={counters}
              hideIndicators={shouldHideIndicators(serviceOrder)}
            />
            <PlaceDetailsPanel place={place} />
            <SchedulingPanel serviceOrder={serviceOrder} />
            <ServiceOrderObservationsPanel serviceOrder={serviceOrder} />
            <CustomFieldsPanel serviceOrder={serviceOrder} />
            <DocumentsDetailsPanel documents={documents} />
            <StatusReasonPanel serviceOrder={serviceOrder} />

            <FlexCol>
              <FlexGrid gutter={0.5} wrap>
                <CheckInOutDetailsPanel type="checkIn" serviceOrder={serviceOrder} />
                <CheckInOutDetailsPanel type="checkOut" serviceOrder={serviceOrder} />
              </FlexGrid>
            </FlexCol>
          </FlexGrid>
        </AccordionContent>
      </Accordion>
    </FlexCol>
  )
}

export default GeneralAccordion
